"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeStore = exports.store = exports.createStoreWithInitialState = void 0;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _helpStorage = require("@ua/help-storage");

var _constants = require("../constants");

var _app = _interopRequireDefault(require("./reducers/app"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var rootReducer = (0, _redux.combineReducers)({
  app: _app.default
});
var expirationTimeMillis = 1000 * 60 * 30; // 30 minute store expiry

var composeEnhancers = global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

var persistMiddleware = function persistMiddleware(store) {
  return function (apply) {
    return function (action) {
      var result = apply(action);
      var nextStateToPersist = store.getState();
      (0, _helpStorage.setItem)(_constants.LOCALSTORAGE_KEY_STORE_EXPIRES, Date.now());
      (0, _helpStorage.setItem)(_constants.LOCALSTORAGE_KEY_STORE, JSON.stringify(nextStateToPersist));
      return result;
    };
  };
};

var createStoreWithInitialState = function createStoreWithInitialState(initialState) {
  return (0, _redux.createStore)(rootReducer, initialState, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default, persistMiddleware)));
};

exports.createStoreWithInitialState = createStoreWithInitialState;
var store = createStoreWithInitialState({});
exports.store = store;

var initializeStore =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref) {
    var env, stateFetchedString, initialState, expires, difference;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            env = _ref.env;
            _context.next = 3;
            return (0, _helpStorage.initialize)({
              env: env
            });

          case 3:
            _context.next = 5;
            return (0, _helpStorage.getItem)(_constants.LOCALSTORAGE_KEY_STORE);

          case 5:
            stateFetchedString = _context.sent;
            initialState = JSON.parse(stateFetchedString); // Reset initial state if past expiry

            _context.t0 = Number;
            _context.next = 10;
            return (0, _helpStorage.getItem)(_constants.LOCALSTORAGE_KEY_STORE_EXPIRES);

          case 10:
            _context.t1 = _context.sent;
            expires = (0, _context.t0)(_context.t1);
            difference = Date.now() - expires;

            if (difference > expirationTimeMillis) {
              initialState = {};
            }

            exports.store = store = createStoreWithInitialState(initialState);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initializeStore(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.initializeStore = initializeStore;